import React from "react";
import { Fab, useTheme, Tooltip } from "@material-ui/core";
import HomeIcon from "@material-ui/icons/Home";
import Box from "@material-ui/core/Box";
import AccessibilityNewRoundedIcon from "@material-ui/icons/AccessibilityNewRounded";
import { A11yContext } from "./A11yContext";

export default React.memo(
  function Actions({ goToHome }) {
    const { palette } = useTheme();
    const { setA11yMode } = React.useContext(A11yContext);

    return (
      <>
        <Box
          position="absolute"
          right={0}
          top={0}
          m={2}
          mt={{ xs: 10, md: 2 }}
          zIndex={9}
          display="flex"
          flexDirection="column"
        >
          <Tooltip
            title="Reset map view"
            aria-label="Reset map view"
            placement="left"
          >
            <Fab
              size="small"
              onClick={goToHome}
              style={{ backgroundColor: palette.white, marginBottom: 16 }}
            >
              <HomeIcon />
            </Fab>
          </Tooltip>
          <Tooltip
            title="Toggle accessible colors"
            aria-label="Toggle accessible colors"
            placement="left"
          >
            <Fab
              size="small"
              onClick={() => setA11yMode(a => !a)}
              style={{ backgroundColor: palette.white }}
              aria-label="toggle visual accessibility mode"
            >
              <AccessibilityNewRoundedIcon />
            </Fab>
          </Tooltip>
        </Box>
      </>
    );
  },
  ({ xs: prev }, { xs: next }) => prev === next
);
